import {AfterViewInit, Component, ElementRef, HostBinding, Input, OnInit, ViewChild} from '@angular/core';
import {DOL_VERSION_JSON} from '../../../../dol-version';
import {UtilsService} from '../../../core/utils/utils.service';

@Component({
    selector: 'yo-infos-version',
    templateUrl: './infos-version.component.html',
    styleUrls: ['./infos-version.component.scss'],
    standalone: false
})
export class InfosVersionComponent implements OnInit, AfterViewInit {

  dolVersionJson = DOL_VERSION_JSON;
  isVisible: boolean = false;

  @Input() showArrow: boolean = true;
  @Input() position: string = 'top';
  @Input() blockMode: boolean = false;

  //TO APPLY on host element the class 'block-mode' if blockMode is true
  @HostBinding('class.block-mode') get isBlockMode() {
    return this.blockMode;
  }

  @ViewChild('versionOverlay') overlay: ElementRef<HTMLDivElement>;

  constructor(public utils: UtilsService) {
  }

  ngOnInit() {
  }

  ngAfterViewInit(): void {
    if (!this.showArrow && this.overlay) {
      this.overlay.nativeElement.classList.add('without-arrow');
    }
  }

  showOverlay(): void {
    this.isVisible = true;
  }

  hideOverlay(): void {
    this.isVisible = false;
  }
}
